// Step2.jsx
import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import back from './images/back.svg';
import { withTranslation } from 'react-i18next';

//import { bounce } from 'react-animations';
import { zoomIn } from 'react-animations';
import { fadeInRight } from 'react-animations';
import Radium, { StyleRoot } from 'radium';

const styles = {

    zoomIn: {
        animation: 'x 1s',
        animationName: Radium.keyframes(zoomIn, 'zoomIn')
    }

    ,
    fadeInRight: {
        animation: 'x 1s',
        animationName: Radium.keyframes(fadeInRight, 'fadeInRight')
    }
}

class Step2 extends Component {

    saveAndContinue = (e) => {
        e.preventDefault()
        this.props.nextStep()
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    render() {
        const { values } = this.props;
        const {t, i18n} = this.props;
      
        return (
            
            <StyleRoot>    
            <Form onSubmit={this.saveAndContinue} id="questionnaire">
                    <fieldset style={values.next === '' ? styles.zoomIn : styles.fadeInRight}>
                    <div className="col-xl-8 offset-xl-2 mt-5 text-center wow fadeInUp">
                            <p className="p-18">2 {t('step.steps')} 5</p>
                            <h2> {t('step2.hi')} {values.firstName}! </h2>
                        {
                            values.generaltext_json.map((obj) => {


                                    return <div key={obj.id} dangerouslySetInnerHTML={{ __html: obj.step2[i18n.language] }}></div>
                            })

                        } 
                    </div>
                    <div className="col-xl-8 offset-xl-2 mt-5 text-center">

                        <div className="row wow fadeInUp">
                            <div className="col-xl-6">
                                <input
                                    type="email"
                                    placeholder={t('step2.email')}
                                    onChange={this.props.handleChange('email')}
                                    defaultValue={values.email}
                                    required
                                />
                            </div>
                            <div className="col-xl-6 mt-4 mt-xl-0">
                                <input
                                    placeholder={t('step2.phone')}
                                    onChange={this.props.handleChange('phone')}
                                    defaultValue={values.phone}
                                />
                            </div>


                        </div>

                        <div className="row">
                            <div className="col-3 d-flex align-items-center">
                                <button onClick={this.back} className="previous previous-arrow mt-5">
                                        <img src={back} alt="back" className="image-flud" />
                                        <p className="p-14 d-none d-md-block "> {t('btn.back')}</p>
                                </button>
								</div>
                            <div className="col-6">
                                    <button type="submit" className="next btn well_btn mt-4  wow fadeInUp btn-lrg">{t('btn.save')}</button>
                            </div>
                        </div>

                    </div>



                </fieldset>  



                  
            </Form>
            </StyleRoot>     
        )
    }
}

export default withTranslation()(Step2);